import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Activity } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export default function AuthCallback() {
  const { handleGoogleCallback } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use ref to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      // Extract session_id from URL fragment
      const hash = location.hash;
      const sessionId = hash.split('session_id=')[1]?.split('&')[0];

      if (!sessionId) {
        navigate('/login');
        return;
      }

      const result = await handleGoogleCallback(sessionId);
      
      if (result.success) {
        // Clean up the URL and redirect
        window.history.replaceState({}, document.title, '/workspace');
        navigate('/workspace', { replace: true });
      } else {
        navigate('/login', { state: { error: result.error } });
      }
    };

    processCallback();
  }, [location, handleGoogleCallback, navigate]);

  return (
    <div className="min-h-screen bg-[#060608] flex items-center justify-center">
      <div className="text-center">
        <Activity className="w-12 h-12 text-[#2E79FF] mx-auto mb-4 animate-pulse" />
        <p className="text-[#A1A1AA]">Completing sign in...</p>
      </div>
    </div>
  );
}
